import {flow} from 'lodash';
import {DOMAIN_VALUE_LANGUAGES_ID} from '@/constants/engine';
import environment from '@/environment';
import i18n, {SupportedLocale} from '@/initializers/i18next';
import {logger} from '@/initializers/logger';
import {Configuration, DomainValueReference, ValueDefinition} from '@/model/types';
import {getDomainValueForLocale} from '@/utils/locale';
import {recursiveReplace} from '../utils/object';

const replace = (search: RegExp, replace: string) => (configuration: Configuration) =>
  recursiveReplace(configuration, search, replace);

export const replaceMetaVariables = (configuration: Configuration): Configuration => {
  let appLocale: DomainValueReference = {$ref: `${DOMAIN_VALUE_LANGUAGES_ID}#0`};

  try {
    appLocale = getDomainValueForLocale(i18n.language as SupportedLocale, configuration.values as ValueDefinition[]);
  } catch {
    logger.warn('Failed to get app locale from configuration values, defaulting to "fr"');
  }

  return flow(
    replace(/\{\$appLocale\}/g, appLocale.$ref),
    replace(/\{\$appVersion\}/g, APP_VERSION),
    replace(/\{\$modelVersion\}/g, configuration.version),
    replace(/\{\$jsonVersion\}/g, configuration.jsonVersion),
    replace(/\{\$baseUrl\}/g, environment.API_BFF_URL),
  )(configuration);
};
